<div class="stepper-wrapper">
  @for (box of listBoxes; track box; let i = $index) {
    <div
      class="stepper-item"
    [ngClass]="{
      complete: app.pcnGenerator.checkCompleted(box)
    }"
      >
      @if (showBox(box)) {
        <button
          class="btn btn-nav p-1"
          (click)="displayBox(box)"
          >
          <div
            class="box-number m-auto"
        [ngClass]="{
          'btn-nav-active': box === app.leftNav.selectedBox,
          'box-number-complete': app.pcnGenerator.checkCompleted(box)
        }"
            >
            @if (!app.pcnGenerator.checkCompleted(box)) {
              <span>{{ i + 1 }}</span>
            }
            @if (app.pcnGenerator.checkCompleted(box)) {
              <i
                class="fal fa-check"
              ></i>
            }
          </div>
          <div
            class="btn-text text-center"
            [ngClass]="{ 'btn-text-active': box === app.leftNav.selectedBox }"
            >
            {{ app.getText(box) }}
          </div>
        </button>
      }
    </div>
  }
</div>
